import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionsTableComponent } from './actions-table.component';
import { MatIconModule } from '@angular/material/icon';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
	declarations: [ActionsTableComponent],
	imports: [CommonModule, MatIconModule, NgxDatatableModule],
	exports: [ActionsTableComponent],
})
export class ActionsTableModule {}
